module.exports = __webpack_public_path__ + "img/alert-circle.63df085d.svg";